import { render } from "./partner-item.vue?vue&type=template&id=54b0d974"
import script from "./partner-item.vue?vue&type=script&lang=js"
export * from "./partner-item.vue?vue&type=script&lang=js"

import "./partner-item.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script